module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/119aad80b53e89a46fabdeab669cea3d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/bronze-certificate.png
// module id = plXt
// module chunks = 1